module.exports = __webpack_public_path__ + "static/media/manabi_about_banner_zh.72f46c06.png";